var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.SubmitRequestOrderChange, Vendd.Order, function (envelope) {
            var options = {
                url: 'AuthService.svc/RequestOrderChange',
                data:
                {
                    email: envelope.message.data.model.Email,
                    code: envelope.message.data.model.OrderCode
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {
                if (response.success === true) {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.SubmitRequestOrderChangeSuccess(response));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.SubmitRequestOrderChangeFailure(response));
                }
            };

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.SubmitRequestOrderChangeFailure(response));
            };

            Vendd.Service.call(options);
        });

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.CancelUncompletedOrder, Vendd.Order, function (envelope) {
            function onSuccess(response) {
                if (response.success) {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.CancelUncompletedOrderSuccess(response));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.CancelUncompletedOrderFailed(response));
                };
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.CancelUncompletedOrderFailed(response));
            }

            var options = {
                url: 'EcomService.svc/CancelUncompletedOrder',
                data: {
                    orderId: envelope.message.data.orderId
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        });

    Vendd.MessageBus.subscribe(Vendd.Order.Messages.ReturnOrderItem, Vendd.Order, function (envelope) {
            function onSuccess(response) {
                if (response.success) {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.ReturnOrderItemSuccess(response));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.ReturnOrderItemFailed(response));
                };
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.Order, new Vendd.Order.Messages.ReturnOrderItemFailed(response));
            }

            var options = {
                url: 'EcomService.svc/ReturnOrderItem',
                data: {
                    orderItemId: envelope.message.data.orderItemId
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            Vendd.Service.call(options);
        });

    Vendd.Order.CreateChangeOrder = function () {

            var changeOrderInfo = {
                Email: '',
                OrderCode: ''
            };


            var observable = new Vendd.Observable(changeOrderInfo);
            return observable;
        };

    Vendd.Order.CreateDefaultChangeOrderValidationModel = function (observable) {

            var defaultValidationModel = ({
                Email: [{ rule: "required" }, { rule: "isEmail" }],
                OrderCode: [{ rule: "required" }]
            });

            var valEngine = Vendd.DataValidation.BuildValidationModel(defaultValidationModel);

            var propertyChanging = function propertyChanging(data, propertyName, value) {

                var valOptions = {
                    ValidationEngine: valEngine,
                    PropertyName: propertyName,
                    PropertyValue: value
                };
                Vendd.DataValidation.Validate(valOptions);
            };

            observable.AddListenerToPropertyChanging('Email', propertyChanging);
            observable.AddListenerToPropertyChanging('OrderCode', propertyChanging);
            return valEngine;
        };

    return Vendd;

})(Vendd || {});